<template>
    <PageTitle :page-title="'Личный кабинет'">
            <div class="page-header__btns">
                <button class="btn btn--border btn--fav" @click="changeTab('favorite')">Избранное<span>({{getFavoriteTendersCount || 0}})</span></button>
                <a href="http://lk.nahodka.market/index.php?r=site%2Flogin" target="_blank" class="btn btn--color btn--sticky">Создать карточку товара</a>
            </div>
    </PageTitle>
    <div class="page-content">
        <div class="wrapper">
            <div class="page-content__wrapper">

                <div class="page-content__aside">
                    <PageNav></PageNav>
                </div>

                <div class="page-content__content">
                    <PageLoader v-if="isLoading"/>
                    <EditSupplierCard/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import PageNav from "@/components/blocks/PageNav.vue";
import PageTitle from "@/components/blocks/PageTitle.vue";
import EditSupplierCard from "@/components/sections/LcSupply/SupplierCard/EditSupplierCard.vue";

export default {
    name: "SupplierPage",
    components: {PageLoader, PageNav, PageTitle, EditSupplierCard},
    data() {
        return {
            currentTab: 'main'
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'isLoading',
            getFavoriteTendersCount: 'tenders/getFavoriteTendersCount'
        })
    },
    methods: {
        changeTab(newTab) {
            this.currentTab = newTab
            this.updatePagination({offset: 0})
        },
        ...mapActions({
            updatePagination: 'tenders/updatePagination',
        })
    }
}
</script>

